export function addMutationObserver(
  element: Element | null | undefined,
  cb: () => void,
) {
  if (element == null) {
    return;
  }

  if (typeof MutationObserver === 'undefined') {
    return;
  }

  const mutationObserver = new MutationObserver(cb);
  mutationObserver.observe(element, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  });

  return () => {
    mutationObserver.disconnect();
  };
}
